export default __webpack_public_path__ + "static/media/fourth.36825126.jpg";